import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    IconButton,
    Button,
    Tabs,
    Tab,
    Box,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import AddEquipment from "../../Modals/addEquipmentModal";
import AddMuscleModal from "../../Modals/addMuscleModal";

function CustomTabPanel(props: any) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            {...other}
        >
            {value === index && <>{children}</>}
        </div>
    );
}

function a11yProps(index: number) {
    return {
        id: `simple-tab-${index}`,
        "aria-controls": `simple-tabpanel-${index}`,
    };
}

const ManageSettings = () => {
    const navigate = useNavigate();

    const [valueTabs, setValueTabs] = useState(0);
    const handleChangeTabs = (event: any, newValue: number) => {
        setValueTabs(newValue);
    };

    const [searchTerm, setSearchTerm] = useState("");

    const [openEquipment, setOpenEquipment] = useState(false);
    const [openMuscle, setOpenMuscle] = useState(false);

    return (
        <>
            {/* Title */}
            <div className="main_title">
                <h1>Settings</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> -
                    Settings
                </p>
            </div>

            {/* Tabs */}
            <div className="table_header">
                <div className="left_s">
                    <Box className="custom_tabs1" sx={{ width: "100%" }}>
                        <Tabs
                            value={valueTabs}
                            onChange={handleChangeTabs}
                            className="custom_tabs_links"
                        >
                            <Tab label="Equipments" {...a11yProps(0)} />
                            <Tab label="Muscle Group" {...a11yProps(1)} />
                        </Tabs>
                    </Box>
                </div>
            </div>

            <div className="cards">

                {/* -------------------------- EQUIPMENTS TAB ----------------------- */}
                <CustomTabPanel value={valueTabs} index={0}>
                    <div className="table_header">
                        <div className="left_s">
                            <SearchBar
                                searchTerm={searchTerm}
                                setDebouncedSearchTerm={setSearchTerm}
                                placeholder="Search Equipment..."
                            />
                        </div>

                        <div className="right_s">
                            <Button
                                className="btn btn_primary"
                                onClick={() => setOpenEquipment(true)}
                            >
                                <AddIcon /> Add Equipment
                            </Button>
                        </div>
                    </div>

                    <TableContainer className="table_container">
                        <Table>
                            <TableHead>
                                <TableRow hover>
                                    <TableCell>Sr.no</TableCell>
                                    <TableCell>Equipment Name</TableCell>
                                    <TableCell>Category</TableCell>
                                    <TableCell>Created Date</TableCell>
                                    <TableCell>Action</TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                <TableRow hover>
                                    <TableCell>1</TableCell>
                                    <TableCell>Dumbbell</TableCell>
                                    <TableCell>Strength</TableCell>
                                    <TableCell>12 Jan 2024</TableCell>
                                    <TableCell>
                                        <div className="table_actions v2">
                                            <IconButton>
                                                <img src="/static/images/edit2_icon.svg" alt="" />
                                            </IconButton>
                                            <IconButton>
                                                <img src="/static/images/trash2_icon.svg" alt="" />
                                            </IconButton>
                                        </div>
                                    </TableCell>
                                </TableRow>

                                <TableRow hover>
                                    <TableCell>2</TableCell>
                                    <TableCell>Barbell</TableCell>
                                    <TableCell>Strength</TableCell>
                                    <TableCell>20 Jan 2024</TableCell>
                                    <TableCell>
                                        <div className="table_actions v2">
                                            <IconButton>
                                                <img src="/static/images/edit2_icon.svg" alt="" />
                                            </IconButton>
                                            <IconButton>
                                                <img src="/static/images/trash2_icon.svg" alt="" />
                                            </IconButton>
                                        </div>
                                    </TableCell>
                                </TableRow>

                            </TableBody>
                        </Table>
                    </TableContainer>
                </CustomTabPanel>

                {/* ----------------------- MUSCLE GROUP TAB ------------------------ */}
                <CustomTabPanel value={valueTabs} index={1}>
                    <div className="table_header">
                        <div className="left_s">
                            <SearchBar
                                searchTerm={searchTerm}
                                setDebouncedSearchTerm={setSearchTerm}
                                placeholder="Search Muscle Group..."
                            />
                        </div>

                        <div className="right_s">
                            <Button
                                className="btn btn_primary"
                                onClick={() => setOpenMuscle(true)}
                            >
                                <AddIcon /> Add Muscle Group
                            </Button>
                        </div>
                    </div>

                    <TableContainer className="table_container">
                        <Table>
                            <TableHead>
                                <TableRow hover>
                                    <TableCell>Sr.no</TableCell>
                                    <TableCell>Muscle Group</TableCell>
                                    <TableCell>Created Date</TableCell>
                                    <TableCell>Action</TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                <TableRow hover>
                                    <TableCell>1</TableCell>
                                    <TableCell>Chest</TableCell>
                                    <TableCell>10 Jan 2024</TableCell>
                                    <TableCell>
                                        <div className="table_actions v2">
                                            <IconButton>
                                                <img src="/static/images/edit2_icon.svg" alt="" />
                                            </IconButton>
                                            <IconButton>
                                                <img src="/static/images/trash2_icon.svg" alt="" />
                                            </IconButton>
                                        </div>
                                    </TableCell>
                                </TableRow>

                                <TableRow hover>
                                    <TableCell>2</TableCell>
                                    <TableCell>Back</TableCell>
                                    <TableCell>18 Jan 2024</TableCell>
                                    <TableCell>
                                        <div className="table_actions v2">
                                            <IconButton>
                                                <img src="/static/images/edit2_icon.svg" alt="" />
                                            </IconButton>
                                            <IconButton>
                                                <img src="/static/images/trash2_icon.svg" alt="" />
                                            </IconButton>
                                        </div>
                                    </TableCell>
                                </TableRow>

                            </TableBody>
                        </Table>
                    </TableContainer>
                </CustomTabPanel>

            </div>

            {/* Modals */}
            <AddEquipment
                open={openEquipment}
                onClose={() => setOpenEquipment(false)}
                setOpen={setOpenEquipment}
            />

            <AddMuscleModal
                open={openMuscle}
                onClose={() => setOpenMuscle(false)}
                setOpen={setOpenMuscle}
            />

        </>
    );
};

export default ManageSettings;
